define(['vue'], function(Vue){
    return new Vue();
});


//////////////////
// WEBPACK FOOTER
// ..m/common/event-bus.js
// module id = 118
// module chunks = 0